import activationYinhai from './activationYinhai.vue'

export default activationYinhai
